import { OrbitProgress } from "react-loading-indicators";

export default function Spinner({size}) {
  return (
    <OrbitProgress color="#53b8aa" size={size}/>
  );
}